import { defineMessages } from 'react-intl'
import LineBalconyIcon from 'LuxKit/Icons/line/LineBalconyIcon'
import LineBedSofaIcon from 'LuxKit/Icons/line/LineBedSofaIcon'
import LineClockPlusIcon from 'LuxKit/Icons/line/LineClockPlusIcon'
import type SvgIcon from 'LuxKit/SvgIcon'
import getOfferFeatureIcon from 'lib/offer/getOfferFeatureIcon'
import type { StayUpgradeHighlightId } from './stayUpgradeModalUtils'

export const highlightIcons: Record<StayUpgradeHighlightId, typeof SvgIcon> = {
  'private-pool': getOfferFeatureIcon('pool'),
  'ocean-view': getOfferFeatureIcon('ocean'),
  'mountain-view': getOfferFeatureIcon('line_mountains_road'),
  'city-view': getOfferFeatureIcon('line_iconic_landmark'),
  'garden-view': getOfferFeatureIcon('garden'),
  balcony: LineBalconyIcon,
  jacuzzi: getOfferFeatureIcon('bathtub'),
  bathtub: getOfferFeatureIcon('bathtub'),
  'living-area': LineBedSofaIcon,
  kitchenette: getOfferFeatureIcon('kitchen'),
  'all-inclusive': getOfferFeatureIcon('crossed_utensils'),
  breakfast: getOfferFeatureIcon('cloche'),
  'kids-stay-free': getOfferFeatureIcon('childs_face'),
  'lounge-access': getOfferFeatureIcon('key'),
  'early-check-in': getOfferFeatureIcon('clock_with_check'),
  'late-checkout': LineClockPlusIcon,
  'room-service': getOfferFeatureIcon('drink_tray'),
  transfers: getOfferFeatureIcon('plane_with_arrows'),
}

export const highlightMessages = defineMessages({
  'private-pool-title': { id: 'CCiPsSQE6_IRZV_imuv7', defaultMessage: 'Private pool' },
  'private-pool-description': { id: 'g95s91tRRbpkEqershtx', defaultMessage: 'All to yourself' },
  'ocean-view-title': { id: 'IGfDEYgo8uYP6fShL2rN', defaultMessage: 'Ocean views' },
  'ocean-view-description': { id: '2ytZ5QnvI3wJBmKc9rJI', defaultMessage: 'Wake up to water views' },
  'mountain-view-title': { id: '7mUzGuVV9FuPj9eh3gJW', defaultMessage: 'Mountain views' },
  'mountain-view-description': { id: 'mt5Jq2lvJ2wK4nyr-XQG', defaultMessage: 'Fresh air and far-reaching views' },
  'city-view-title': { id: '_Eadf4qvVEyxhimBpOyE', defaultMessage: 'City views' },
  'city-view-description': { id: '4HIzRPG8Txu0LMZMG0fo', defaultMessage: 'Skyline right outside your window' },
  'garden-view-title': { id: 'gpILcRjIszZgKgUPwGR-', defaultMessage: 'Garden views' },
  'garden-view-description': { id: 'q1mt1j578QsDsphTb6eq', defaultMessage: 'To unwind and take in' },
  'balcony-title': { id: 'iLqui9iFca2Cpv9anQCA', defaultMessage: 'Private balcony' },
  'balcony-description': { id: 'dgHoHKvKvecM74iKEIva', defaultMessage: 'Your own space to take in the views' },
  'jacuzzi-title': { id: 'cQyegEK4444vmtRyMEJk', defaultMessage: 'Jacuzzi' },
  'jacuzzi-description': { id: 'BNJNntzTq1z6fzN2rB-a', defaultMessage: 'Soak it all in' },
  'bathtub-title': { id: 'CIyhDHgd43ELmCUyPX39', defaultMessage: 'Bathtub' },
  'bathtub-description': { id: 'MC8aBDhiUTNFZQnArcBa', defaultMessage: 'Draw a bath and soak the day away' },
  'living-area-title': { id: '_OmTj_PCLTnRspLaZpF6', defaultMessage: 'Separate living area' },
  'living-area-description': { id: 'qssRDjFSKnQmPAwh4udo', defaultMessage: 'More space to spread out and relax' },
  'kitchenette-title': { id: 'oCt3kR8jiYxpypTCjiIP', defaultMessage: 'Kitchenette' },
  'kitchenette-description': { id: 'bkOBobuyu5tz-WxmnyXl', defaultMessage: 'Self-catering convenience in your room' },
  'all-inclusive-title': { id: 'UDnw7mQUlm27SliUeWdG', defaultMessage: 'All-inclusive' },
  'all-inclusive-description': { id: 'sBYoAp31NSdPac601POT', defaultMessage: 'Food, drinks and more, all included' },
  'breakfast-title': { id: 'Tsv0DDOQNUZdW02a_G0E', defaultMessage: 'Daily breakfast' },
  'breakfast-description': { id: 'vf412bDK7p5rhi3nSmmr', defaultMessage: 'Start your day the right way' },
  'kids-stay-free-title': { id: 'CNugEAaPm248zDee9zYR', defaultMessage: 'Kids stay free' },
  'kids-stay-free-description': { id: 'B0e2ZR08k44oMvduVIAT', defaultMessage: 'Bring the little ones at no extra cost' },
  'lounge-access-title': { id: '3b7dBQGltOL1EbWo4pPj', defaultMessage: 'Lounge access' },
  'lounge-access-description': { id: 'oJm5alrfUsDK1vX17XRE', defaultMessage: 'Enjoy exclusive club lounge privileges' },
  'early-check-in-title': { id: 'Xc2yxjCwgFRmQQHrhPVb', defaultMessage: 'Early check-in' },
  'early-check-in-description': { id: 'NT4My3p92442MpQUerAv', defaultMessage: 'Settle in sooner and start relaxing' },
  'late-checkout-title': { id: '1VN6lhqtCgkZtyWXwX0B', defaultMessage: 'Late checkout' },
  'late-checkout-description': { id: 'QVSA6Fj1kOuUpCb8kqq4', defaultMessage: 'More time to unwind.' },
  'room-service-title': { id: '6d0lf51c7qQpdzmExUlS', defaultMessage: 'Room service' },
  'room-service-description': { id: 'M1MwETGS_sWjEUVPv5_A', defaultMessage: 'Dine without leaving your room' },
  'transfers-title': { id: 'zFCGHHltqJDglfc0CP2W', defaultMessage: 'Airport transfers' },
  'transfers-description': { id: 'c1DpaxBBjzBGhUQRDWUA', defaultMessage: 'Arrive and depart with ease' },
})
